import { Link } from "react-router-dom";
import logoDark from "../assets/brand/logo-dark.png";
import logoLight from "../assets/brand/logo-light.png";

export default function Logo({ light = false, className = "", height = 36 }) {
  return (
    <Link
      to="/"
      className={`inline-flex items-center gap-2 group transition-opacity hover:opacity-85 ${className}`}
      data-testid="logo-link"
      aria-label="The Queen — Accueil"
    >
      <img
        src={light ? logoLight : logoDark}
        alt="The Queen Haute Dermatologie"
        style={{ height: `${height}px`, width: "auto" }}
        className="object-contain"
        onError={(e) => {
          // Fallback if image fails to load
          e.target.style.display = "none";
          e.target.nextSibling.style.display = "flex";
        }}
      />
      <span
        style={{ display: "none" }}
        className="items-baseline font-body tracking-tight text-xl font-medium"
      >
        <span className="font-light mr-0.5" style={{ color: light ? "#FFFFFF" : "#111111" }}>the</span>
        <span className="font-semibold tracking-normal text-2xl" style={{ color: light ? "#FFFFFF" : "#111111" }}>Queen</span>
      </span>
    </Link>
  );
}
